import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OFFICE_KEY } from '@components/offices-dialog/offices-dialog';
import { StorageDataAccess } from '@data-access/storage.data-access';

export const officeInterceptor: HttpInterceptorFn = (request, next) => {
  const office =
    inject<StorageDataAccess<string>>(StorageDataAccess).getItem(OFFICE_KEY);
  const router = inject(Router);

  if (request.url.includes('/login')) {
    return next(request);
  }

  if (office) {
    request = request.clone({
      setHeaders: {
        Sucursal: `${office}`,
      },
    });
  } else {
    router.navigateByUrl('/dashboard');
  }

  return next(request);
};
